<template>

<core-dropdown class="input" trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick">

	<core-button
		v-on:click.native="onToggleClick"
		:tooltip="compactTooltip"
		:caret="true"
		theme="filter"
		:icon="icon"
		:text="(isCompact && !$isMobile) ? false : layoutName"
		:icon-only="isCompact && !$isMobile"
		:icon-left="$isMobile"
	/>
	
	<portal to="mobileactions" v-if="$isMobile && $route.meta.hasActions">

		<core-button 
			v-on:click.native="onToggleClick" 
			theme="filter" 
			icon="table-layout" 
			text="View" 
			:icon-left="true" 
		/>
	
	</portal>
	
	<core-dropdown-list title="Views" class="input-options" :expanded="is.expanded" theme="filter" :caret="true" type="button" v-on:close="is.expanded = false">

		<core-dropdown-item type="title" text="Custom Views" v-if="views.length" />

		<core-dropdown-item type="link" v-for="view in views" :key="view.id" :is-ticked="selectedView === view.id" v-on:click.native.stop="onLayoutClick(view.id)">{{ view.name }}</core-dropdown-item>

		<core-dropdown-item type="divide" v-if="views.length" />

		<core-dropdown-item type="title" text="Standard Views" v-if="views.length" />

		<div class="layout-defaults">

			<div v-on:click="onLayoutClick('list')" class="layout-defaults-item is-list">List</div>
			<div v-on:click="onLayoutClick('sheet')" class="layout-defaults-item is-sheet">Sheet</div>
			<div v-on:click="onLayoutClick('grid')" class="layout-defaults-item is-grid">Cards</div>
			<div v-on:click="onLayoutClick('gallery')" class="layout-defaults-item is-gallery">Gallery</div>

		</div>

		<template v-if="$isSelf">
		
			<core-dropdown-item type="divide" />

			<core-dropdown-item type="link" v-on:click.native.stop="onManageClick">Manage views</core-dropdown-item>

		</template>

	</core-dropdown-list>

</core-dropdown>

</template>

<script>

import vClickOutside from 'v-click-outside'
import $templates from 'app/components/common/view/templates'
import barRightState from './bar/state'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: [
		'filter', 'page'
	],

	data: function() {

		return {
			is: {
				expanded: false
			}
		}

	},

	computed: {

		selectedView: function() {

			return this.$currentView

		},

		isCompact: function() {

			return barRightState.layout

		},

		compactTooltip: function() {

			if (this.isCompact && this.selectedView) {

				return 'Views (' + this.selectedView.name + ')'

			}

			return 'Views'

		},

		icon: function() {

			if(!this.$currentView) return false

			if (this.$currentView.type === 1) {

				return 'list-tree'

			} else if (this.$currentView.type === 2) {

				return 'table-cells'

			} else if (this.$currentView.type === 3) {

				return 'grid'

			} else if (this.$currentView.type === 4) {

				return 'image'

			}

			return false

		},

		layoutName: function() {

			if(this.selectedView.id === 'list') {

				return '<b>List</b>'

			} else if(this.selectedView.id === 'grid') {

				return '<b>Cards</b>'

			} else if(this.selectedView.id === 'sheet') {

				return '<b>Sheet</b>'

			} else if(this.selectedView.id === 'gallery') {

				return '<b>Gallery</b>'

			} else {

				return (this.selectedView) ? '<b>' + this.selectedView.name + '</b>' : false

			}

		},

		views: function() {

			var context = 0

			if (this.$currentViewContext === 'collection') context = 1
			if (this.$currentViewContext === 'ratings') context = 2
			if (this.$currentViewContext === 'plays') context = 3
			if (this.$currentViewContext === 'gameplays') context = 4

			return this.$_.filter(this.$store.getters['data/views/list'], function(view) {

				return view.context === context

			})

		},

	},

	methods: {

		resolveProfileDefaultLayout: function(layoutCtx) {

			// Mirrors getView() in mixin/Shortcuts.js — config layout
			// (set by Set Default alongside any view_default flag) is
			// the single source of truth for explicit user choice.
			var profileConfig = this.$store.getters['context/config']
			if (profileConfig && profileConfig[layoutCtx] && profileConfig[layoutCtx].layout) {

				return profileConfig[layoutCtx].layout

			}

			var contextType = this.$store.getters['context/type']
			var typeKey = (contextType === 'users') ? 'user' : ((contextType === 'groups') ? 'group' : 'buddies')

			if ($templates[typeKey] && $templates[typeKey][layoutCtx]) {

				return $templates[typeKey][layoutCtx].default

			}

			return ''

		},

		onLayoutClick: function(value) {

			this.$store.commit('filter/' + ((this.$currentViewContext === 'gameplays') ? 'config/gameplays/layout' : this.filter), value)

			this.is.expanded = false

			// Reflect the layout choice in the URL so the link can be
			// shared, bookmarked, or saved into a preset. Omit the
			// param when the chosen layout matches the viewed
			// profile's saved default — keeps default-view URLs
			// clean.
			var layoutCtx = this.$currentViewContext
			if (this.$_.contains(['collection', 'plays', 'ratings', 'gameplays'], layoutCtx)) {
				var defaultLayout = this.resolveProfileDefaultLayout(layoutCtx)
				var nextQuery = Object.assign({}, this.$route.query)

				if (value && String(value) !== String(defaultLayout) && value !== 0) {
					nextQuery.layout = value
				} else {
					delete nextQuery.layout
				}

				this.$router.replace({ query: nextQuery }).catch(function() {})
			}

		},

		onCreateClick: function() {

			this.$pubsub.$emit('open.modal', 'viewsManageCreate')

			this.is.expanded = false

		},

		onManageClick: function() {

			this.$pubsub.$emit('open.modal', 'viewsManage')

			this.is.expanded = false

		},

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			this.is.expanded = false

		}

	}

}

</script>

<style scoped>

.layout-defaults {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	grid-gap: 2px;
	padding: 3px 10px 5px 10px;
}

.layout-defaults-item {
	border-radius: 4px;
	font-size: 12px;
	height: 24px;
	cursor: pointer;
	font-weight: 500;
	text-align: center;
    color: #0a2b3d;
	line-height: 24px;
}

.layout-defaults-item.is-list {
    background-color: #E9C46A;
}

.layout-defaults-item.is-sheet {
    background-color: #CBA6F7;
}

.layout-defaults-item.is-grid {
    background-color: #6EC5E9;
}

.layout-defaults-item.is-gallery {
    background-color: #74e493;
}

.layout-defaults-item.is-list:hover {
    background-color: #d6b25b;
}

.layout-defaults-item.is-sheet:hover {
    background-color: #b68fe4;
}

.layout-defaults-item.is-grid:hover {
    background-color: #60b5d9;
}

.layout-defaults-item.is-gallery:hover {
    background-color: #5fd37f;
}

</style>
